/**
 * SBB-specific API path helpers + Zurich Card branch.
 * Core airline/hotel/session logic lives in `airlineTransportContext.ts`.
 */

import {
  buildAirlineNavigationState,
  clearPersistedAirlineRouterState,
  persistAirlineFromNavigationState,
  readPersistedAirlineRouterState,
  resolveTransportAirlineApiContext,
  type TransportAirlineApiContext
} from "./airlineTransportContext";

export type SbbTransportApiContext = TransportAirlineApiContext;

export const persistAirlineSbbFromNavigationState = persistAirlineFromNavigationState;

export const readPersistedAirlineSbbRouterState = readPersistedAirlineRouterState;

export const clearPersistedAirlineSbbRouterState = clearPersistedAirlineRouterState;

export const buildSbbNavigationState = buildAirlineNavigationState;

export function resolveSbbTransportApiContext(isZurichCard: boolean, locationState: unknown): SbbTransportApiContext {
  if (isZurichCard) {
    return { mode: "hotel" };
  }
  return resolveTransportAirlineApiContext(locationState);
}

export function getAirportSbbTransportsBasePath(iataCode: string): string {
  return `v1/airports/${encodeURIComponent(iataCode)}/transports/sbb`;
}

export function getAirportBookingsPath(iataCode: string): string {
  return `v1/airports/${encodeURIComponent(iataCode)}/bookings`;
}
